// Mock data for C T. Portfolio Website

export const personalInfo = {
  name: "Cherise T.",
  title: "Digital Innovation / Transformation",
  tagline: "Driving Innovation Through Strategy, Systems & Storytelling",
  bridge: "We bridge the trust for tomorrow. Divine Intelligence Illuminates, Human Intelligence Leads, AI Intelligence Expands©",
  motto: "YAH HEALTH WEALTH HAPPINESS The Universal Pillars Of Success",
  philosophy: "A.R.T. Energi (Authenticity | Reliability | Truth) Triad Of Excellence",
  location: "North Carolina",
  email: "hello@artenergi.org",
  linkedin: "https://www.linkedin.com/in/cherise-t-332aa31/"
};

export const aboutMe = {
  description: "Built on the foundation of A.R.T. Energi — Authenticity, Reliability, and Truth — this portfolio is a living testimony and a declaration that divine purpose and professional excellence are not separate paths. Through the hand of YAH, what you see here represents over a decade of digital transformation, brand strategy, and creative innovation driven by a dynamic, results-oriented Digital Innovation & AI Generalist with a diverse background in IT operations, consulting, content strategy, and customer-centric design thinking. Every project, every system, every design is fruit from a tree rooted in FAST (Faith A Sacred Trust) — a proven track record in driving innovation through alchemization, problem solving, and cross-functional collaboration. The work speaks because Yah Spirit leads.",
  highlights: [
    "Architeching end-to-end frameworks, procedures, and infrastructure systems to drive successful and sustainable organizational experiences",
    "Enhancing digital experiences through data-driven insights",
    "Enabling high-performing teams and creating operational excellence",
    "Focusing on Authenticity | Reliability | Truth, The Triad of Excellence in the YHWH יהוה Ecosystem"
  ],
  mission: "Passionate about enabling high-performing teams and creating operational excellence across hybrid work environments operating in A.R.T. Energi, empowering a culture of excellence towards YAH HEALTH WEALTH HAPPINESS - The Universal Pillars Of Success."
};

export const coreCompetencies = [
  {
    category: "Strategic Leadership",
    skills: [
      "Digital Transformation & Innovation Strategy",
      "Continuous Improvement through Ambiguity",
      "Stakeholder & Cross-functional Team Leadership",
      "Strategic Planning | Vendor & Partner Liaison"
    ]
  },
  {
    category: "Technical Generalist", 
    skills: [
      "Infrastructure Deployment (LAN/WAN/Voice/IPT)",
      "Good Documentation Practices (GDP)",
      "Access Control, IT Governance, Security",
      "Data Analysis, Visualization, Process Optimization & Problem Solving"
    ]
  },
  {
    category: "Customer Experience",
    skills: [
      "Customer Experience (CX), Journey Mapping",
      "Content Strategy & Brand Positioning", 
      "Service & Support (Remote Problem Solving)",
      "Performance Management & Team Development"
    ]
  },
  {
    category: "Risk & Resource Management",
    skills: [
      "Risk Mitigation | Budget & Resource Allocation",
      "Task Delegation & Process Optimization",
      "Feedback, Process & Team Development",
      "Creativity - A.R.T Energi (Authenticity | Reliability | Truth)"
    ]
  }
];

export const experience = [
  {
    id: 1,
    // company: "World Of Inspiyah",  This line is commented out
    position: "Creative Strategist",
    // period: "September 2021 - Current",
    description: "Leading digital transformation initiatives and creative program development",
    achievements: [
      "Delivered weekly content campaigns and blogs aligned with brand identity (YHWH יהוה) YAH HEALTH WEALTH HAPPINESS",
      "Executed website redesign & content creation for major social media product launch",
      "Lead proactive risk management efforts—anticipating challenges and developing strategies",
      "Collaborated weekly with business stakeholders to maintain brand integrity"
    ]
  },
  {
    id: 2,
   // company: "Cameo Global", This line is commented out
    position: "Implementation Project Manager - Network Services", 
  // period: "June 2019 - June 2020",
    description: "Managing small / medium-scale infrastructure deployment projects",
    achievements: [
      "Successfully led at-scale infrastructure deployment projects end-to-end",
      "Utilized Smartsheet for project visibility, automation, and global team coordination",
      "Ensured compliance with GDP standards throughout project lifecycle",
      "Oversaw planning, quality, scheduling, task management, and vendor coordination"
    ]
  },
  {
    id: 3,
   // company: "Wipro.", This line is commented out
    position: "Digital Operation Analyst / Engineer - Contact Center Tech.",
  // period: "May 2016 - April 2019", 
    description: "Supporting enterprise contact center technology migration and operations",
    achievements: [
      "Supported Unified Contact Center Enterprise (UCCE) migration",
      "Drove catalog standardization, data quality improvements, and service request resolution",
      "Provisioned users, call routing settings, and devices via IPT, TNM, Unity VMB, and ICM",
      "Delivered technical support ensuring configuration accuracy, efficiency, and uptime"
    ]
  },
  {
    id: 4,
    // company: "STS", This line is commented out
    position: "Employee Experience Program Lead - Acquisitions",
  // period: "August 2012 - May 2016",
    description: "Leading global cross-functional acquisitions integration programs",
    achievements: [
      "Lead global cross-functional acquisitions integration programs",
      "Defined roadmaps, personas, team strategies and best practice support frameworks", 
      "Managed talent alignment, skills assessment, and strategic onboarding initiatives",
      "Designed and delivered performance management reviews and professional development plans"
    ]
  }
];

export const projects = [
  {
    id: 1,
    title: "INSPIYAH CULTURE",
    description: "YAH SPIRIT + STREETWEAR = INSPIYAH CULTURE. Drip to sculpture the Inspiyah Culture.",
    category: "Spiritual Brand Development",
    technologies: ["Adobe Creative Suite", "E-commerce Platform", "Brand Strategy", "Digital Marketing", "Content Creation"],
    outcomes: [
      "Spiritual streetwear brand combining faith and fashion",
      "Creating A.R.T Energi & FLY FREQUENCY messaging that resonates with spiritual community",
      "Developed a unique brand identity as a boaster in YHWH יהוה, merging culture with ancient principles",
      "Planting seeds of anticipation with Yahffirmations to INSPIYAH CULTURE",
      "Designed enterprise-scale ecommerce platform for global spiritual fashion revolution"
    ],
    duration: "Conceptulization",
    role: "Creative Director & Brand Strategist"
  },
  /*{
    id: 8 alternative after launch this is commented out by /*,
    title: "INSPIYAH CULTURE",
    description: "YAH SPIRIT + STREETWEAR = INSPIYAH CULTURE. On 888 I open heaven's gate and introduce a revolutionary spiritual streetwear brand that lets YAH Spirit sear its word on every soul. Drip to sculpture Inspiyah Culture - transforming fashion into sacred art through the 1010 portal.",
    category: "Spiritual Brand Development",
    technologies: ["Adobe Creative Suite", "E-commerce Platform", "Brand Strategy", "Digital Marketing", "Content Creation"],
    outcomes: [
      "Launched groundbreaking spiritual streetwear brand combining faith and fashion",
      "Created authentic messaging that resonates with spiritual community",
      "Developed unique brand identity merging street culture with ancient wisdom",
      "Built anticipation with 888 numerology and sacred timing for launches",
      "Designed enterprise-scale ecommerce platform for global spiritual fashion revolution"
    ],
    duration: "Ongoing",
    role: "Creative Director & Brand Strategist"
  },*/
  {
    id: 2,
    title: "INSPIYAH MAIL: Mind Unplugged",
    description: "A transformational content platform and LinkedIn thought leadership branch that bridges spiritual wisdom with professional development. Creating authentic content that connects ancient principles to modern workplace and life challenges.",
    category: "Content Strategy & Thought Leadership",
    technologies: ["Content Management", "LinkedIn Publishing", "Blog Development", "Social Media Strategy", "Spiritual Coaching"],
    outcomes: [
      "Established authentic thought leadership voice combining spirituality and professional growth",
      "Built engaged community around YAH HEALTH WEALTH HAPPINESS principles",
      "Created LinkedIn content strategy that showcases professional and spiritual integration",
      "Developed unique positioning as 'Keeper Of The Fiyah' in digital transformation space",
      "Generated meaningful conversations around authentic leadership in corporate environments"
    ],
    duration: "September 2021 - Current",
    role: "Content Creator & Thought Leader"
  },
  {
    id: 3,
    title: "Enterprise Contact Center Migration (UCCE)",
    description: "Led the migration of Telephony, & Unified Contact Center Enterprise customers, assisted with implementation of collaboration ecosystem, catalog standardization and data quality improvements.",
    category: "Infrastructure Transformation",
    technologies: ["IPT", "TNM", "Unity VMB", "ICM", "UCCE"],
    outcomes: [
      "Improved system efficiency by 40%",
      "Reduced service request resolution time",
      "Enhanced configuration accuracy and uptime",
      "Streamlined call routing processes, troubleshooting and customer support"
    ],
    duration: "18 months",
    role: "Digital Operations Analyst/Engineer"
  },
  {
    id: 3,
    title: "Global Infrastructure Deployment Program",
    description: "Managed end-to-end planning and execution of small to medium - scale network infrastructure deployments across multiple global locations.",
    category: "Voice & Network Services",
    technologies: ["Smartsheet", "LAN/WAN", "Voice Systems", "Project Management Tools"],
    outcomes: [
      "Successfully deployed infrastructure across 15+ locations",
      "Maintained GDP compliance throughout project lifecycle", 
      "Achieved 98% on-time delivery rate",
      "Improved cross-team collaboration and visibility"
    ],
    duration: "12 months",
    role: "Implementation Project Manager"
  },
  {
    id: 4,
    title: "Multi-Company Acquisitions Integration",
    description: "Designed and executed comprehensive integration programs for newly acquired companies, focusing on transition alignment and support integration.",
    category: "Digital Transformation",
    technologies: ["Support Management Systems", "Tools and Processes", "Integration Frameworks"],
    outcomes: [
      "Successfully integrated 30+ acquired companies",
      "Reduced integration timeline by 50%",
      "Improved employee support experience rate during transitions",
      "Established best practice frameworks for future Acquisitions & Divestiture"
    ],
    duration: "4 years",
    role: "Employee Experience Program Lead"
  },
  {
    id: 5,
    title: "Digital Brand Transformation Initiative",
    description: "Led comprehensive website redesign and content strategy overhaul in preparation for major product launch, ensuring brand consistency and stakeholder alignment.",
    category: "Brand & Content Strategy",
    technologies: ["WordPress", "Adobe Creative Suite", "Content Management", "Brand Strategy", "AI Technologies",],
    outcomes: [
      "Increased brand consistency across all digital touchpoints",
      "Improved content engagement metrics by 60%",
      "Successfully launched major social media product",
      "Enhanced stakeholder satisfaction and brand integrity"
    ],
    duration: "Ongoing",
    role: "Creative Program Art Director"
  }
];

export const toolsExpertise = [
  {
    category: "Content & Design",
    tools: ["WordPress", "Adobe Creative Suite", "Canva", "Affinity", "AI Tools"]
  },
  {
    category: "Technical Systems",
    tools: ["Cisco IPT/TNM/Unity", "ICM", "Visual Studio", "HTML Templates", "SQL Basic Queries"]
  },
  {
    category: "Project Management",
    tools: ["Microsoft Office Suite", "Smartsheet", "Jira", "Box", "Collaboration Tools"]
  },
  {
    category: "Customer Relationship",
    tools: ["HubSpot CRM", "Change Management Tools", "Performance Management Systems"]
  }
];

export const certifications = [
  "AWS Practitioner 2022 / AWS Cloud Certification Of Completion 2025",
  "ITIL Foundation",
  "Scrum Alliance - Certified Scrum Product Owner", 
  "Scaled Agile (SAFe) - Certified Practitioner",
  "Masters Institute - Associate of Applied Science Systems Admin.",
  "Generative AI Mastermind 2025"
];

export const volunteerWork = [
  {
    title: "Spiritual Wellness Project",
    role: "Blog Writer & Content Creator",
    period: "September 2021 - Current",
    description: "Creating content focused on spiritual wellness and personal development"
  },
  {
    title: "Technology Education Project", 
    role: "Technical/Non-Technical Assistant",
    period: "2018 - 2021",
    description: "Supporting ideation, collaboration, app development, and presentation skills development"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Entering the 1010 Portal: Your Transformation Begins Now",
    excerpt: "A journey of disconnecting and reconnecting to YAH spirit in a whole new way. Discover what it means to be INSPIYAHED to get your spiritual foundation together.",
    content: "The 1010 portal isn't just a moment in time—it's a spiritual doorway to authentic transformation. When I first felt the call to get my spiritual life together, I didn't realize I was stepping into something so profound...",
    category: "Transformation",
    readTime: "5 min read",
    publishDate: "2024-01-15",
    tags: ["1010 Portal", "Transformation", "YAH Spirit", "Spiritual Growth"],
    featured: true
  },
  {
    id: 2,
    title: "Faith.Love.Yah: The Trinity of Authentic Living",
    excerpt: "Breaking down what FLY FREQUENCY truly means and how these three pillars create the foundation for everything - from personal wellness to professional excellence.",
    content: "Faith isn't just belief—it's the unwavering trust that guides every decision. Love isn't just emotion—it's the force that connects us to our purpose. And Yah isn't just a name—it's the source of all authentic power. Together, they create the FLY FREQUENCY that elevates our spiritual vibration...",
    category: "Faith & Spirituality",
    readTime: "7 min read", 
    publishDate: "2024-01-08",
    tags: ["Faith", "Love", "YAH", "Authentic Living", "Spiritual Foundation"],
    featured: true
  },
  {
    id: 3,
    title: "My Blood is Red: Unity Beyond Surface Differences",
    excerpt: "Exploring the truth that connects us all—we relate more than we disagree. A meditation on copper skin, red blood, and shared humanity.",
    content: "My skin may be copper colored but my blood is red. This simple truth holds profound wisdom about human connection and the illusions that divide us...",
    category: "Unity & Connection",
    readTime: "4 min read",
    publishDate: "2024-01-01", 
    tags: ["Unity", "Human Connection", "Spiritual Wisdom", "Truth"],
    featured: false
  },
  {
    id: 4,
    title: "YAH HEALTH WEALTH HAPPINESS: The Universal Pillars",
    excerpt: "Understanding how spiritual foundation (Yah), physical wellness (Health), material abundance (Wealth), and inner joy (Happiness) work together.",
    content: "These aren't separate goals—they're interconnected pillars that support a life of authentic abundance. When Yah is your foundation, everything else aligns...",
    category: "Holistic Living",
    readTime: "6 min read",
    publishDate: "2023-12-25",
    tags: ["YAH", "Health", "Wealth", "Happiness", "Holistic Living", "Abundance"],
    featured: false
  },
  {
    id: 5,
    title: "From Digital Transformation to Soul Transformation",
    excerpt: "How my professional work in technology mirrors the inner work of spiritual growth. The systems, processes, and methodologies that transform organizations also transform souls.",
    content: "Every digital transformation project I've led has taught me something about personal transformation. The same principles that revolutionize businesses can revolutionize lives...",
    category: "Integration",
    readTime: "8 min read",
    publishDate: "2023-12-18",
    tags: ["Professional Growth", "Spiritual Growth", "Integration", "Transformation"],
    featured: false
  },
  {
    id: 6,
    title: "Ancient Principles for Modern Problems",
    excerpt: "Isaiah 43:10 reminds us we are witnesses and chosen servants. How ancient wisdom provides solutions for contemporary challenges in faith, work, and relationships.",
    content: "You are my witness declares YHWH יהוה, yes my servant whom I have chosen, so that you may know and have faith in me. These words from Isaiah speak directly to our modern struggles...",
    category: "Ancient Wisdom",
    readTime: "5 min read",
    publishDate: "2023-12-11",
    tags: ["Isaiah 43:10", "Ancient Wisdom", "Modern Application", "Faith", "Purpose"],
    featured: false
  }
];

export const blogCategories = [
  "All Posts",
  "Transformation", 
  "Faith & Spirituality",
  "Unity & Connection",
  "Holistic Living",
  "Integration",
  "Ancient Wisdom"
];

export const projectCategories = [
  "All",
  "Spiritual Brand Development",
  "Content Strategy & Thought Leadership",
  "Infrastructure Transformation", 
  "Network Services",
  "Digital Transformation",
  "Brand & Content Strategy"
];